<template>
  <v-container>
    <v-row class="justify-center">
      <v-col cols="12" class="pl-0 pb-0">
        <v-card-title class="breakword pb-0"
          ><span class="font-weight-bold">Hair Loss Clients<br /><br /></span
          >How much do you think you can charge in total for the MicroLines
          topper + your installation fee?<br /><br /><span class="smaller-text"
            >Keep in mind, MicroLines are a handcrafted, luxury product made
            with 100% real human hair.</span
          >
        </v-card-title></v-col
      >
      <v-card-text class="text-center subtitle">Choose one</v-card-text>
      <v-col
        v-for="option in options"
        :key="option.value"
        class="d-flex justify-center flex-column align-center pb-0 pt-0"
        :class="$vuetify.breakpoint.smAndDown ? 'px-1' : 'px-3'"
        cols="6"
        @click="handleSelect(option.value)"
      >
        <v-btn
          depressed
          :color="answer === option.value ? 'user_cta' : 'user_btn'"
          :dark="answer === option.value"
          class="text-none mt-1"
          width="100%"
          >{{ option.text }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    data() {
      return {
        answer: '',
        options: [
          {
            text: '$100 to $500',
            value: '$100 to $500'
          },
          {
            text: '$500 to $1000',
            value: '$500 to $1000'
          },
          {
            text: '$1000 to $2000',
            value: '$1000 to $2000'
          },
          {
            text: '$2000 to $3000+',
            value: '$2000 to $3000+'
          }
        ],
        field: 'microlinesApplicationSpend',
        screen: 'stylist-restoration2',
        nextScreen: ''
      }
    },
    methods: {
      ...mapActions([
        'setApplicationData',
        'setCurrentScreen',
        'setNextScreen',
        'setIsValid'
      ]),
      handleNextScreen() {
        // 1. if answer is $500 to $1000
        if (this.answer === '$500 to $1000') {
          this.nextScreen = 'stylist-restoration2_1'
        }
        // 2. if answer is not $500 to $1000
        else {
          this.nextScreen = 'stylist-restoration3'
        }
        this.setNextScreen(this.nextScreen)
      },
      handleSelect(answer) {
        this.answer = answer
        // 1. set data
        this.setApplicationData({ field: this.field, answer })
        // 2. set next screen depending on this component logic
        this.handleNextScreen()
        // 3. set valid depending on this component logic
        this.setIsValid(true)
        // 4. go to next screen
        this.$emit('next')
      }
    },
    created() {
      // 1. set current screen
      this.setCurrentScreen(this.screen)
      // 2. set answer, sent next screen and valid if data exists
      if (this.$store.state.applications.application[this.field]) {
        this.answer = this.$store.state.applications.application[this.field]
        this.handleNextScreen()
        this.setIsValid(true)
      }
      // 3. set valid if data doesn't exist
      else {
        this.setIsValid(false)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .system-img {
    cursor: pointer;
  }
  .btn-caption {
    color: #7d7d7d;
    font-size: 10px;
  }
  .breakword {
    word-break: break-word;
  }
  .smaller-text {
    font-size: 0.85em;
  }
</style>
